/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputDivisionShort } from './OutputDivisionShort';
import {
    OutputDivisionShortFromJSON,
    OutputDivisionShortFromJSONTyped,
    OutputDivisionShortToJSON,
} from './OutputDivisionShort';
import type { OutputPositionShort } from './OutputPositionShort';
import {
    OutputPositionShortFromJSON,
    OutputPositionShortFromJSONTyped,
    OutputPositionShortToJSON,
} from './OutputPositionShort';
import type { OutputTeamShort } from './OutputTeamShort';
import {
    OutputTeamShortFromJSON,
    OutputTeamShortFromJSONTyped,
    OutputTeamShortToJSON,
} from './OutputTeamShort';
import type { OutputUserShort } from './OutputUserShort';
import {
    OutputUserShortFromJSON,
    OutputUserShortFromJSONTyped,
    OutputUserShortToJSON,
} from './OutputUserShort';
import type { OutputZoneShort } from './OutputZoneShort';
import {
    OutputZoneShortFromJSON,
    OutputZoneShortFromJSONTyped,
    OutputZoneShortToJSON,
} from './OutputZoneShort';

/**
 * 
 * @export
 * @interface OutputAdminSession
 */
export interface OutputAdminSession {
    /**
     * 
     * @type {string}
     * @memberof OutputAdminSession
     */
    createdAt: string;
    /**
     * 
     * @type {OutputUserShort}
     * @memberof OutputAdminSession
     */
    createdBy: OutputUserShort;
    /**
     * 
     * @type {OutputDivisionShort}
     * @memberof OutputAdminSession
     */
    division?: OutputDivisionShort;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminSession
     */
    expiresAt: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminSession
     */
    finishedAt: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminSession
     */
    id: number;
    /**
     * 
     * @type {OutputPositionShort}
     * @memberof OutputAdminSession
     */
    position?: OutputPositionShort;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminSession
     */
    status: string;
    /**
     * 
     * @type {OutputTeamShort}
     * @memberof OutputAdminSession
     */
    team?: OutputTeamShort;
    /**
     * 
     * @type {Array<OutputUserShort>}
     * @memberof OutputAdminSession
     */
    users: Array<OutputUserShort>;
    /**
     * 
     * @type {Array<OutputZoneShort>}
     * @memberof OutputAdminSession
     */
    zones: Array<OutputZoneShort>;
}

/**
 * Check if a given object implements the OutputAdminSession interface.
 */
export function instanceOfOutputAdminSession(value: object): boolean {
    if (!('createdAt' in value)) return false;
    if (!('createdBy' in value)) return false;
    if (!('expiresAt' in value)) return false;
    if (!('finishedAt' in value)) return false;
    if (!('id' in value)) return false;
    if (!('status' in value)) return false;
    if (!('users' in value)) return false;
    if (!('zones' in value)) return false;
    return true;
}

export function OutputAdminSessionFromJSON(json: any): OutputAdminSession {
    return OutputAdminSessionFromJSONTyped(json, false);
}

export function OutputAdminSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminSession {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'createdBy': OutputUserShortFromJSON(json['createdBy']),
        'division': json['division'] == null ? undefined : OutputDivisionShortFromJSON(json['division']),
        'expiresAt': json['expiresAt'],
        'finishedAt': json['finishedAt'],
        'id': json['id'],
        'position': json['position'] == null ? undefined : OutputPositionShortFromJSON(json['position']),
        'status': json['status'],
        'team': json['team'] == null ? undefined : OutputTeamShortFromJSON(json['team']),
        'users': ((json['users'] as Array<any>).map(OutputUserShortFromJSON)),
        'zones': ((json['zones'] as Array<any>).map(OutputZoneShortFromJSON)),
    };
}

export function OutputAdminSessionToJSON(value?: OutputAdminSession | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': value['createdAt'],
        'createdBy': OutputUserShortToJSON(value['createdBy']),
        'division': OutputDivisionShortToJSON(value['division']),
        'expiresAt': value['expiresAt'],
        'finishedAt': value['finishedAt'],
        'id': value['id'],
        'position': OutputPositionShortToJSON(value['position']),
        'status': value['status'],
        'team': OutputTeamShortToJSON(value['team']),
        'users': ((value['users'] as Array<any>).map(OutputUserShortToJSON)),
        'zones': ((value['zones'] as Array<any>).map(OutputZoneShortToJSON)),
    };
}

